import { buildProps, definePropType, mutable } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const alertRuleProps = buildProps({
  title: {
    type: String,
    default: "",
  },
  rules: {
    type: definePropType<string[]>(Array),
    default: () => mutable([] as const),
  },
} as const);

export type XAlertRuleProps = ExtractPropTypes<typeof alertRuleProps>;
